module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/octopus-mobile-portuguese.94ccf405.jpg";